import React from "react";
import { Control, useFieldArray, Controller } from "react-hook-form";
import { Box, Button, Input, Text } from "rizzui";
import { PiTrashBold } from "react-icons/pi";
import { FormData } from "../types";

interface ABSDSectionProps {
  control: Control<FormData>;
}

const ABSDSection: React.FC<ABSDSectionProps> = ({ control }) => {
  const {
    fields: absdFields,
    append: absdAppend,
    remove: absdRemove,
  } = useFieldArray({
    control,
    name: "absdRates",
  });

  return (
    <Box>
      <div className="pb-6 md:p-6 border-b border-gray-200">
        <h3 className="text-lg font-semibold">
          Additional Buyer Stamp Duty (ABSD) Rates
        </h3>
        <Text className="text-sm text-gray-600 mt-1">
          Configure ABSD rates by citizenship and property count
        </Text>
      </div>
      <div className="pt-6 md:p-6 space-y-4">
        {absdFields.map((field, index) => (
          <div key={field.id} className="border rounded-lg p-4 space-y-4">
            <div className="flex items-center justify-between">
              <Controller
                name={`absdRates.${index}.citizenship`}
                control={control}
                render={({ field }) => (
                  <Input
                    {...field}
                    placeholder="Singaporean / Singapore PR / Foreigner / Corporate"
                    className="font-medium"
                  />
                )}
              />
              {absdFields.length > 1 && (
                <Button
                  variant="text"
                  color="danger"
                  size="sm"
                  onClick={() => absdRemove(index)}
                >
                  <PiTrashBold className="h-4 w-4" />
                </Button>
              )}
            </div>
            <div className="grid grid-cols-3 gap-4">
              <Controller
                name={`absdRates.${index}.firstProperty`}
                control={control}
                render={({ field }) => (
                  <div>
                    <Text className="text-sm font-medium mb-1">
                      First Property (%)
                    </Text>
                    <Input
                      type="number"
                      {...field}
                      onChange={(e) => field.onChange(Number(e.target.value))}
                      placeholder="0"
                    />
                  </div>
                )}
              />
              <Controller
                name={`absdRates.${index}.secondProperty`}
                control={control}
                render={({ field }) => (
                  <div>
                    <Text className="text-sm font-medium mb-1">
                      Second Property (%)
                    </Text>
                    <Input
                      type="number"
                      {...field}
                      onChange={(e) => field.onChange(Number(e.target.value))}
                      placeholder="0"
                    />
                  </div>
                )}
              />
              <Controller
                name={`absdRates.${index}.thirdPlusProperty`}
                control={control}
                render={({ field }) => (
                  <div>
                    <Text className="text-sm font-medium mb-1">
                      Third+ Properties (%)
                    </Text>
                    <Input
                      type="number"
                      {...field}
                      onChange={(e) => field.onChange(Number(e.target.value))}
                      placeholder="0"
                    />
                  </div>
                )}
              />
            </div>
          </div>
        ))}
      </div>
    </Box>
  );
};

export default ABSDSection;
